<template>
  <div class="your-routine-section-filter">
    <u-dropdown
      v-if="isMobileLayout"
      :value="activeCategory"
      :options="sectionCategories"
      icon="filter"
      class="your-routine-section-filter__dropdown"
      @input="onSelectCategory"
    >
      <template #value>{{ $t(activeCategory.labelKey) }}</template>
      <template #option="{ option }">
        {{ $t(option.labelKey) }}
      </template>
    </u-dropdown>

    <ul v-if="!isMobileLayout" class="your-routine-section-filter__categories-list categories-list">
      <li
        v-for="category of sectionCategories"
        :key="category.labelKey"
        class="categories-list__category u-typography-helvetica u-text u-text--m u-text--l-gte1440"
        :class="{ 'categories-list__category--active': category.value === activeCategory.value }"
        @click="onSelectCategory(category)"
      >
        {{ $t(category.labelKey) }}
      </li>
    </ul>
  </div>
</template>

<script>
import { UDropdown } from 'universkin-shared';
import { FILTER_CONFIG } from '@/constants/your-routine';

export default {
  name: 'YourRoutineSectionFilter',
  components: { UDropdown },
  props: {
    activeCategory: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      sectionCategories: Object.values(FILTER_CONFIG)
    };
  },
  computed: {
    isMobileLayout() {
      return this.$windowWidth.value < 960;
    }
  },
  methods: {
    onSelectCategory(section) {
      this.$emit('category-selected', section);
    }
  }
};
</script>

<style lang="scss" scoped>
.your-routine-section-filter {
  &__dropdown {
    width: 100%;
    margin-bottom: 40px;
  }
}

@media (min-width: 960px) {
  .your-routine-section-filter {
    .categories-list {
      &__category {
        margin-bottom: 10px;
        padding-inline-start: 10px;
        list-style-type: none;
        cursor: pointer;

        &--active {
          list-style-type: disc;
          color: var(--u-color-grey-500);

          &::marker {
            content: '\2022';
            font-size: 16px;
            color: var(--u-color-grey-900);
          }
        }
      }
    }
  }
}
</style>
